import React, { useEffect, useState } from "react";

// Components
import Img from "components/Img";
import AnimationLogo from "./AnimationLogo";
import SliderComponent from "components/SliderComponent";

// Lib
import { shallowEqual } from "react-redux";
import { useAppSelector } from "lib/hooks/useDispatch";

// Constants
import { requiredCatNumbers } from "constans/landing";

export const Banner: React.FC = () => {
  const { libraries } = useAppSelector((store) => {
    return {
      libraries: store.libraries
    };
  }, shallowEqual);

  const [widthCarousel, setWidthCarousel] = useState<number>(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const filteredData = libraries?.data?.filter(item => requiredCatNumbers?.includes(item?.catNumber || '')) || [];

  useEffect(() => {
    const htmlWrapperSmallSlider = document.querySelector(".s1__small-slider");

    if (htmlWrapperSmallSlider) {
      setWidthCarousel(htmlWrapperSmallSlider?.clientWidth);
    }
  }, [filteredData]);

  const settings = {
    isArrows: true,
    infinite: true,
    slidesToShow: 3,
    centerMode: false,
    width: widthCarousel,
    lengthArray: filteredData?.length
  };

  return (
    <>
      <div className="s1">
        <div className="wrapper">
          <div className="s1__content-top flex flex-ai-center flex-jc-between">
            <div className="s1__content-top--left">
              <h1 className="s1__title">
                <span>E</span>namine<br />
                <span>B</span>ioactive<br />
                <span>C</span>ompounds
              </h1>
            </div>
            <AnimationLogo />
          </div>

          {!!filteredData?.length && <SliderComponent
            isSmall
            innerPadding={0}
            data={filteredData}
            settings={settings}
            className="s1__small-slider"
          />}
        </div>
      </div>

      <div className="s1__content-bottom">
        <Img
          name="img2S2"
          alt="Image dna"
          classNameWrapper="s1__img-2"
        />
        <div className="wrapper flex flex-ai-start flex-jc-between flex-direction-column">
          <div className="s1__content-bottom--left flex-jc-end flex-jc-start-desktop">
            <div className="s1__ul-wrapper s1__ul-wrapper--border">
              <p className="s1__ul-title">Our products</p>
              <ul className="s1__ul">
                <li>a wide array of biologically active molecules</li>
                <li>approved drugs</li>
                <li>drug impurities and metabolites</li>
                <li>novel lead compounds</li>
                <li>natural compounds and tool compounds for scientists</li>
              </ul>
            </div>
          </div>

          <div className="s1__content-bottom--right">
            <div className="s1__ul-wrapper">
              <p className="s1__ul-title">Our services</p>
              <ul className="s1__ul">
                <li><span>We provide</span> for all molecules annotation of their biological activity, which is
                  referenced in the scientific literature
                </li>
                <li><span>We offer</span> pre-plated libraries of compounds collected by appropriate type of action,
                  participation in some pathways, activity coefficient values, chemical beauty etc
                </li>
                <li><span>We can</span> select compounds according to your requirements, for example: targets, type of
                  action or coefficient of activity
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;